import { createAsyncAction } from 'redux-promise-middleware-actions';
import settings from '../settings';

export const getClientInfoAPI = createAsyncAction('GET_CLIENT_INFO', async (quotationId) => {
    const headers = {
        'Content-Type': 'application/json'
    };
    const res = await fetch(`${settings.quotationUrlBase}form-builder/form-saved-data/${quotationId}`, { headers })
        .then((response) => validateResponse(response))
        .catch((error) => {
            throw exeptionCodeResponse(error);
        });
    return res;
});

const validateResponse = (response) => {
    if (response.ok) {
        return response.json();
    } else {
        throw exeptionCodeResponse();
    }
};

const exeptionCodeResponse = (error = 'error') => {
    return error;
};
